export interface IDataChangedWarning {
    show: boolean,
    title: string,
    href: string
}